import { AppAlert, AppCard, AppLoadingSpinner } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useOpportunitySummary } from '@opportunities/-hooks/useOpportunitySummary'
import { DateTime } from 'luxon'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export function CreateOpportunitySummaryChart() {
  // 当日の日付を取得（YYYY-MM-DD形式）※-7日の計算はバックエンド側で行う
  const startAt = DateTime.local().toFormat('yyyy-MM-dd')

  // サマリーデータを取得
  const { data, isLoading, error } = useOpportunitySummary({
    startAt,
  })

  // ローディング中
  if (isLoading) {
    return (
      <AppCard title='週間オポ起票数TOP10'>
        <div className='h-64 flex items-center justify-center'>
          <AppLoadingSpinner text='読み込み中...' size='small' />
        </div>
      </AppCard>
    )
  }

  // エラー時
  if (error) {
    return (
      <AppCard title='週間オポ起票数TOP10'>
        <div className='h-64 flex items-center justify-center'>
          <AppAlert type='error'>
            データの取得に失敗しました。
            {error.message && <div className='mt-1 text-xs opacity-80'>{error.message}</div>}
          </AppAlert>
        </div>
      </AppCard>
    )
  }

  const summaries = data?.summaries ?? []

  // TOP10を抽出してチャート用データに変換
  const chartData = summaries
    .filter((summary) => summary.totalCreateOpportunity > 0)
    .sort((a, b) => b.totalCreateOpportunity - a.totalCreateOpportunity)
    .slice(0, 10)
    .map((summary) => ({
      name: `${summary.memberName}_${summary.memberEmployeeNumber ?? ''}`,
      起票数: summary.totalCreateOpportunity,
    }))

  // データが空の場合
  if (chartData.length === 0) {
    return (
      <AppCard title='週間オポ起票数TOP10'>
        <div className='h-64 flex items-center justify-center text-muted-foreground'>データがありません</div>
      </AppCard>
    )
  }

  return (
    <AppCard title='週間オポ起票数TOP10'>
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={chartData} margin={{ left: 20, right: 10, top: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' angle={-45} textAnchor='end' height={100} fontSize={12} />
          <YAxis
            width={60}
            allowDecimals={false}
            label={{ value: '起票数', angle: -90, position: 'insideLeft', offset: 10 }}
            fontSize={12}
          />
          <Tooltip formatter={(value) => `${value}件`} />
          <Bar dataKey='起票数' fill='#ef4444' barSize={40} />
        </BarChart>
      </ResponsiveContainer>
    </AppCard>
  )
}
